import { useEffect } from 'react';
import { C } from '../../data/managerReviewData';
import { useVoiceRecorder } from './useVoiceRecorder';
import type { RecorderStatus } from './useVoiceRecorder';

interface VoiceButtonProps {
  onStart: () => void;
  onStop: (result: { segments: string[]; lang: 'en-US' | 'de-DE' }) => void;
  onError?: () => void;
}

export default function VoiceButton({ onStart, onStop, onError }: VoiceButtonProps) {
  const { status, supported, fatalError, start, stop } = useVoiceRecorder();

  useEffect(() => {
    if (fatalError) onError?.();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fatalError]);

  if (!supported) return null;
  const isActive = status !== 'inactive';
  const toggle = async () => {
    if (isActive) { const result = await stop(); onStop(result); } else { onStart(); start(); }
  };
  return (
    <div style={{ position: 'relative', display: 'inline-flex', alignItems: 'center' }}>
      <button onClick={() => { void toggle(); }} title={isActive ? 'Stop recording' : 'Record'} style={{
        padding: '5px 12px', borderRadius: 6,
        border: '1px solid ' + (isActive ? C.red : C.border),
        background: isActive ? '#fff5f5' : '#fff',
        cursor: 'pointer', display: 'flex', alignItems: 'center',
        gap: 5, fontSize: 12, fontWeight: 600, fontFamily: 'Inter',
        color: isActive ? C.red : C.muted, transition: 'all 0.15s',
      }}>
        {isActive ? (<><SpeechIndicator status={status} />Stop</>) : (<><span style={{ fontSize: 13 }}>🎙</span> Record</>)}
      </button>
      <style>{`
        @keyframes voicePulse { 0%, 100% { opacity: 1; transform: scale(1); } 50% { opacity: 0.5; transform: scale(0.75); } }
        @keyframes voiceBars { 0%, 100% { transform: scaleY(0.4); } 50% { transform: scaleY(1); } }
      `}</style>
    </div>
  );
}

function SpeechIndicator({ status }: { status: RecorderStatus }) {
  if (status === 'speechActive') {
    return (
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 1, height: 10 }}>
        {[0, 1, 2].map(i => (
          <span key={i} style={{ width: 2, height: 10, borderRadius: 1, background: C.red, display: 'inline-block', transformOrigin: 'center', animation: 'voiceBars 0.6s ease-in-out ' + (i * 0.15) + 's infinite' }} />
        ))}
      </span>
    );
  }
  return (<span style={{ width: 7, height: 7, borderRadius: '50%', background: C.red, display: 'inline-block', animation: 'voicePulse 1.5s ease-in-out infinite' }} />);
}
